import { z } from "zod/v4";

/**
 * Pagination search params: page and pageSize. Design to be `.extend()`-ed into page-specific search schemas.
 */
export const paginationSearchSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().default(40),
});

/** Default values for pagination search params; values not explicitly set will be omitted from URL. */
export const PAGINATION_SEARCH_DEFAULTS = {
  page: 1,
  pageSize: 40,
};

export type PaginationSearch = z.infer<typeof paginationSearchSchema>;
